import { Component, inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GateConfigElement } from '../../../lib/interfaces/company';
import { GenericStream } from '../../../lib/interfaces/generic-streams';
import { GenericStreamsService } from '../../../service/generic-streams.service';
import { UserGateConfigService } from '../../../service/user-gate-config.service';

@Component({
  selector: 'app-edit-user-gates',
  standalone: false,
  templateUrl: './edit-user-gates.component.html',
  styleUrl: './edit-user-gates.component.scss'
})
export class EditUserGatesComponent implements OnInit{
    public data = inject<{ companyId: string; userGateConfig: GateConfigElement[] }>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef<EditUserGatesComponent>);
    readonly userGateService = inject(UserGateConfigService);
    readonly dataService = inject(GenericStreamsService);

    public gateList: GateConfigElement[] = [];
    public streamList: GenericStream[] = [];

    public showAddStream: boolean = false;
    public addingGate: number = -1;
    public selectedStreamId: FormControl = new FormControl();

    public async ngOnInit(): Promise<void>{
        console.log("Data", this.data);
        if (this.data.userGateConfig) {
            this.gateList = this.data.userGateConfig;
        }
        const result = await this.dataService.getGenericStreams();
        if (result !== false) {
            this.streamList = result;
        }
        console.log("Streams",this.streamList)
    }

    public addStreamClick(gateNumber: number): void {
        this.addingGate = gateNumber;
        this.showAddStream = true;
    }

    public removeGate(gateNr:number): void {
        this.gateList = this.gateList.filter(gate => gate.orderNr !== gateNr);
        this.addingGate = -1;
        this.showAddStream = false;
    }

    public addStreamToGate(): void {
        if (this.selectedStreamId.value && this.selectedStreamId.value !== '') {
            this.gateList.forEach(gate => {
                if (gate.orderNr === this.addingGate) {
                    gate.streamIdList.push({
                        streamId: this.selectedStreamId.value,
                        streamName: this.streamList.find(s => s.id === this.selectedStreamId.value)?.name ?? '',
                        orderNr: gate.streamIdList.length
                    });
                }
            });
            this.selectedStreamId.setValue(null);
        }
    }

    public closeAddStream(): void {
        this.showAddStream = false;
        this.selectedStreamId.setValue(null);
    }

    public createGate(): void {
        const orderNr = this.gateList.length;
        this.gateList.push({
            orderNr: orderNr,
            name:'Gate '+ (orderNr + 1),
            streamIdList:[]
        });
    }
    public close():void {
        this.dialogRef.close();
    }

    public save(): void {
        this.dialogRef.close(this.gateList);
    }
    public removeStreamClick(gateNumber: number, streamIndex:number): void {
        this.gateList.forEach(gate => {
            if (gate.orderNr === gateNumber) {
                gate.streamIdList.splice(streamIndex, 1);
            }
        });
    }
}
